module.exports = __webpack_public_path__ + "img/4.1568ec24.jpg";